import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import config from "../../config/config";
import NotificationSystem from "react-notification-system";
import { Table, TableBody, TableRow, TableRowColumn } from "material-ui/Table";
import { tdStyle } from "../Questionnaire/QuestionnaireTable";
import { IconButton } from "material-ui";
import guesturl from "../../images/guesturl.png";
import joinroom from "../../images/joinroom.png";
import settings from "../../images/gear.png";
import { CopyURLDialog, OtherRoomActions } from "./RoomActionDialog";
import { TableHeader } from "material-ui/Table";

class SessionsRoomMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rooms: [],
      showCopyRoomDialog: false,
      showOtherActionDialog: false,
      selectedHostURL: "",
      selectedGuestURL: "",
      selectedRoom: null
    };
    this.lockEnable = true;
  }

  joinRoom = (val) => {
    if (this.lockEnable) {
      window.open(this.copyHostURL(val));
    } else {
      window.open(this.copyURL(val.fvroom_name));
    }
  };

  joinWebinar = (val) => {
    window.open(this.copyWebinarPublisherUrl(val));
  };

  url = (name) => {
    let url = "https://" + this.props.domainUrlName + ".lfv.jp/" + name;
    let subDomain =
      config.URI === "https://workshop.tokyo" ? "fv" : "video-dev";

    if (this.props.domainType === "Path Domain") {
      url =
        "https://" +
        subDomain +
        ".lfv.jp/" +
        this.props.domainUrlName +
        "/" +
        name;
    }

    if (this.props.admin_guest_url) {
      url += "?video=true";
    }
    return url;
  };
  copyURL = (name) => {
    return this.url(name);
  };
  copyGuestURL = (name) => {
    let url = "";
    url = "https://" + this.props.domainUrlName + ".lfv.jp/" + name;
    return url;
  };

  copyWebinarUrl = (name) => {
    let url = this.copyURL(name);
    return url;
  };

  copyWebinarPublisherUrl = (val) => {
    let webinarUrl = this.props.admin_guest_url
      ? "&publisher=true"
      : "?publisher=true";
    let url = this.copyURL(val.fvroom_name) + webinarUrl;
    if (val.locked && val.hosttoken) {
      url += `&hosttoken=${val.hosttoken}`;
    }
    return url;
  };

  copyHostURL = (val) => {
    let url = this.copyURL(val.fvroom_name);
    if (val.locked && val.hosttoken) {
      let hostUrlParam = this.props.admin_guest_url
        ? "&hosttoken="
        : "?hosttoken=";
      url = this.copyURL(val.fvroom_name) + hostUrlParam + val.hosttoken;
    } else {
      url = url + "?host=true";
    }

    return url;
  };

  showURLCopiedNotification = (key) => {
    const { intl } = this.props;
    const notification = this.refs.notificationSystem;
    notification.addNotification({
      message: intl.formatMessage({ id: `loggedInNavigation.${key}` }),
      level: "success",
      position: "tc",
      autoDismiss: 3,
    });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleInvitationEmail = (room, isWebinar) => {
    this.setState({ showOtherActionDialog: false });

    let hostURL = isWebinar
      ? this.copyWebinarPublisherUrl(room)
      : this.copyHostURL(room);

    let guestURL = isWebinar
      ? this.copyWebinarUrl(room.fvroom_name)
      : this.copyURL(room.fvroom_name);
    
    this.props.handleInvitationEmail(room, hostURL, guestURL);
  };

  openCopyRoomDialog = (val) => {
    const selectedGuestURL = this.props.isWebinar
      ? this.copyWebinarUrl(val.fvroom_name)
      : this.copyURL(val.fvroom_name);

    const selectedHostURL = this.props.isWebinar
      ? this.copyWebinarPublisherUrl(val)
      : this.copyHostURL(val);

    this.setState({ selectedGuestURL, selectedHostURL }, () => {
      this.setState({ showCopyRoomDialog: true });
    });
  };

  openOtherActionDialog = (room) => {
    this.setState({ showOtherActionDialog: true, selectedRoom: room });
  };

  handleCopyRoomDialogClose = () => {
    this.setState({ showCopyRoomDialog: false, selectedGuestURL: '', selectedHostURL: '' });
  };

  handleOtherActionDialogClose = () => {
    this.setState({ showOtherActionDialog: false, selectedRoom: null });
  };

  render() {
    const notificationStyleMobile = {
      NotificationItem: {
        DefaultStyle: {
          fontSize: "14px",
          width: this.props.view === "mobile" ? "45vw" : "unset",
          right: "unset",
          top: "50px",
          position: "relative",
          padding: "5px 20px 5px 6px",
          margin: 0,
          display: "flex",
          alignItems: "center",
          marginBottom: "8px",
        },
      },
      Containers: {
        tc: {
          top: this.props.view === "mobile" ? "6%" : "10%",
        },
      },
    };

    return (
      <div
        style={{
          marginTop: "10px",
        }}
      >
        <NotificationSystem
          ref="notificationSystem"
          style={notificationStyleMobile}
        />

        <CopyURLDialog
          open={this.state.showCopyRoomDialog}
          handleClose={this.handleCopyRoomDialogClose}
          hostURL={this.state.selectedHostURL}
          guestURL={this.state.selectedGuestURL}
          onUrlCopied={this.showURLCopiedNotification}
          isWebinar={this.props.isWebinar}
        />

        <OtherRoomActions
          open={this.state.showOtherActionDialog}
          handleClose={this.handleOtherActionDialogClose}
          selectedRoom={this.state.selectedRoom}
          isWebinar={this.props.isWebinar}
          editRoom={(val) => {
            this.props.editRoom(val);
            this.setState({ showOtherActionDialog: false });
          }}
          handleInvitationEmail={this.handleInvitationEmail}
        />
        <div className="table-wrapper">
          <Table
            selectable={false}
            selectedColor="black"
            height="72vh"
            style={{ border: "1px solid #b8b8b8" }}
          >
            <TableHeader displaySelectAll={false} enableSelectAll={false} adjustForCheckbox={false}>
              <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn colSpan={1} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomList.roomName" />}
                </TableRowColumn>

                <TableRowColumn colSpan={1} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomList.copyUrl" />}
                </TableRowColumn>

                <TableRowColumn colSpan={1} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomList.enterRoom" />}
                </TableRowColumn>

                <TableRowColumn colSpan={1} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomList.other" />}
                </TableRowColumn>
              </TableRow>
              </TableHeader>

              <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>

              {this.props.isFetching ||
                (this.props.rooms.length === 0 && (
                  <TableRow
                    selected={false}
                    className="light-row"
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                      color: "rgb(107, 124, 147)",
                    }}
                  >
                    <TableRowColumn colSpan={4} style={tdStyle}>
                      {this.props.isFetching ? (
                        <FormattedMessage id="roomList.fetchingRooms" />
                      ) : (
                        <FormattedMessage id="roomList.noRoom" />
                      )}
                    </TableRowColumn>
                  </TableRow>
                ))}

              {this.props.rooms.map((val, index) => {
                return (
                  <TableRow
                    key={index}
                    selected={false}
                    className={index % 2 == 0 ? "dark-row" : "light-row"}
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn colSpan={1} style={tdStyle}>
                      <p> {val.fvroom_name} </p>
                    </TableRowColumn>
                    <TableRowColumn colSpan={1} style={tdStyle}>
                      <IconButton
                        iconStyle={{ width: "20px" }}
                        touchRippleColor="green"
                        onClick={() => this.openCopyRoomDialog(val)}
                      >
                        <img src={guesturl} />
                      </IconButton>
                    </TableRowColumn>

                    <TableRowColumn colSpan={1} style={tdStyle}>
                      <IconButton
                        onTouchTap={(e) => {
                          this.props.isWebinar
                            ? this.joinWebinar(val)
                            : this.joinRoom(val);
                        }}
                        touchRippleColor="green"
                        tooltip={
                          <FormattedMessage id="loggedInNavigation.enterRoom" />
                        }
                      >
                        <img
                          className="mobile-joinroom"
                          src={joinroom}
                          alt={"部屋に入る"}
                        />
                      </IconButton>
                    </TableRowColumn>

                    <TableRowColumn colSpan={1} style={tdStyle}>
                      <IconButton
                        onTouchTap={() => this.openOtherActionDialog(val)}
                        touchRippleColor="green"
                        tooltip={
                          <FormattedMessage id="loggedInNavigation.enterRoom" />
                        }
                      >
                        <img
                          className="mobile-joinroom"
                          src={settings}
                          alt={"部屋に入る"}
                        />
                      </IconButton>
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

export default injectIntl(SessionsRoomMobile);



// WEBPACK FOOTER //
// src/components/Seminars/SessionsRoomMobile.js